//LOGIN
export const LOGIN = "auth/login";
export const FORGOT_PASSWORD = "auth/forgot-password";
export const VERIFY_OTP = "auth/verify-otp";
export const RESET_PASSWORD = "auth/reset-password";
export const VALIDATE_UUID = "auth/validate-uuid";
export const NEW_USER_RESET_PASSWORD = "auth/new-user/reset-password";
export const GET_LOGGED_IN_USER_DETAILS = "auth/regenerate-token";

// BRANCHES
export const GET_ALL_BRANCHES = "admin/branch/all";
export const ADD_BRANCH = "admin/branch/add";
export const UPDATE_BRANCH = "admin/branch/update-branch";
export const GET_BRANCHES_LIST = "admin/branch/list";
export const GET_BRANCH_DETAILS = "admin/branch/details";
export const UPDATE_BRANCH_STATUS = "admin/branch/update-status";
export const DELETE_BRANCH = "admin/branch/delete";
export const BRANCH_LIST_BY_CITY = "admin/branch/branch-list-by-city";
export const BRANCH_LIST_WITH_CITY = "admin/branch/branch-list-with-city";
export const SYNC_LOCKS = "admin/common/syncLocks";

// WORKSPACE, WORKSHOP, MEETING ROOMS
export const GET_ALL_WORKSPACES = "admin/space/all";
export const ADD_WORKSPACE = "admin/space/add";
export const GET_WORKSPACE_DETAILS = "admin/space/details";
export const UPDATE_WORKSPACE = "admin/space/update-space";
export const CASHBACK_UPDATE = "admin/cashback/update";
export const UPDATE_WORKSPACE_STATUS = "admin/space/update-status";
export const DELETE_WORKSPACE = "admin/space/delete";
export const CLONE_SPACE = "admin/space/clone-space";
export const GET_MEETING_ROOMS_LIST = "admin/space/meeting-rooms-list";
export const GET_WORKSPACE_LIST = "admin/space/work-space-list";
export const GET_WORKSPACE_BOOKING_DETAILS =
  "admin/space/space-booking-details";
export const CHECK_ENTIRE_BRANCH =
  "admin/space/space-booking-details-by-branch";
export const GET_ALL_WORKSHOP_REQUEST = "admin/workshop-request/all";
export const GET_WORKSHOP_REQUEST_DETAILS = "admin/workshop-request/details";
export const UPDATE_WORKSHOP_REQUEST_STATUS =
  "admin/workshop-request/update-request-status";
export const UPDATE_WORKSHOP_REQUEST = "admin/workshop-request/update-request";
export const GET_WORKSHOP_INVOICE = "admin/space/workshop-invoice";
export const GET_SPACE_LIST_BY_TYPE = "admin/space/space-list-by-type";
export const GET_ALL_WEBSITE_REQUESTS = "admin/enquiry/all";
export const UPDATE_WORKSHOP_REQUEST_SHARE =
  "admin/workshop-request/update-request-share";
export const GET_NEW_WORKSHOP_REQUEST_COUNT =
  "admin/workshop-request/new-request-count";
export const UPDATE_NEW_WORKSHOP_REQUEST_COUNT =
  "admin/workshop-request/update-new-request-count";
export const GET_ENABLE_DISABLE_SPACE_STATUS =
  "admin/space/enable-disable-status";
export const UPDATE_ENABLE_DISABLE_SPACE_STATUS =
  "admin/space/update-enable-disable-status";

// ORGANISATION
export const GET_ALL_ORGANISATION = "admin/organization/all";
export const UPDATE_ORGANISATION_STATUS = "admin/organization/update-status";
export const INVITE_ORGANISATION = "admin/organization/invite";
export const ORGANIZATION_SETTING_DETAILS =
  "admin/organization/settings/details";
export const UPDATE_ORGANIZATION_SETTING = "admin/organization/settings/update";
export const GET_ORGANIZATION_MANAGER_DETAILS =
  "admin/organization/manager/details";
export const UPDATE_ORGANIZATION_MANAGER = "admin/organization/manager/update";

// COUNTRIES
export const GET_ALL_COUNTRIES = "organization/public/countries";

export const GET_ORGANISATION_LIST = "admin/organization/list";
export const GET_ORGANISATION_DETAILS = "admin/organization/details";

// CITIES
export const GET_ALL_CITY = "admin/city/all";
export const GET_CITY_LIST = "admin/city/list";
export const ADD_CITY = "admin/city/add";
export const UPDATE_CITY = "admin/city/update-city";
export const GET_CITY_DETAILS = "admin/city/details";
export const UPDATE_CITY_STATUS = "admin/city/update-status";
export const DELETE_CITY = "admin/city/delete";
// REWARD
export const GET_REWARD_LIST = "admin/rewards/list";
export const GET_CASHBACK_LIST = "admin/cashback/list";
export const UPDATE_REWARD_SCREEN = "admin/rewards/update-reward-screen";
export const UPDATE_REFERRAL_CODE = "admin/rewards/update-referral-settings";
export const GET_REWARD_SETTING_LIST =
  "admin/settings/rewards-settings-last-updated-info";

// AMENITIES
export const GET_ALL_AMENITY = "admin/amenity/all";
export const GET_AMENITY_LIST = "admin/amenity/list";
export const ADD_AMENITY = "admin/amenity/add";
export const UPDATE_AMENITY = "admin/amenity/update-amenity";
export const DELETE_AMENITY = "admin/amenity/delete";
export const UPDATE_AMENITY_STATUS = "admin/amenity/update-status";
export const GET_AMENITY_DETAILS = "admin/amenity/details";

// USERS
export const GET_ALL_USERS = "admin/user/all";
export const ADD_USER = "admin/user/add";
export const UPDATE_USER = "admin/user/details/update";
export const GET_USER_DETAILS = "admin/user/details";
export const UPDATE_USER_STATUS = "admin/user/details/update-status";
export const DELETE_USER = "admin/user/delete";

// ROLES
export const GET_ALL_ROLES = "admin/role/all";
export const GET_ROLES_LIST = "admin/role/list";
export const ADD_ROLE = "admin/role/add";
export const UPDATE_ROLE = "admin/role/update-role";
export const ROLE_DETAILS = "admin/role/details";
export const UPDATE_ROLE_STATUS = "admin/role/update-status";
export const DELETE_ROLE = "admin/role/delete";

// COUPONS
export const GET_ALL_COUPONS = "admin/coupon/all";
export const ADD_COUPON = "admin/coupon/add";
export const UPDATE_COUPON = "admin/coupon/update-coupon";
export const GET_COUPON_LIST = "admin/coupon/list";
export const GET_COUPON_DETAILS = "admin/coupon/details";
export const UPDATE_COUPON_STATUS = "admin/coupon/update-status";
export const DELETE_COUPON_STATUS = "admin/coupon/delete";
export const CLONE_COUPON = "admin/coupon/clone-coupon";

// GLOBAL SETTING
export const GET_GLOBAL_SETTINGS = "admin/onBoardingScreen/list";
export const UPDATE_GLOBAL_SETTINGS = "admin/settings/update-global-settings";
export const UPDATE_INTRO_PAGE_DETAILS =
  "admin/onBoardingScreen/update-settings";
export const GET_PAGE_CONTENT = "common/page-content/get-by-type";
export const UPDATE_PAGE_CONTENT = "common/page-content/update-by-type";
export const GET_SETTINGS_LIST =
  "admin/settings/global-settings-last-updated-info";
export const GET_BANKS_LIST = "admin/common/banks";
export const API_LOGS = "api-logs/all";
export const API_LOG_DETAILS = "api-logs/details";

// CLOSURE
export const GET_ALL_CLOSURES = "admin/closure/all";
export const ADD_CLOSURE = "admin/closure/add";
export const GET_CLOSURE_DETAILS = "admin/closure/details";
export const UPDATE_CLOSURE = "admin/closure/details/update";
export const UPDATE_CLOSURE_STATUS = "admin/closure/details/update-status";
export const DELETE_CLOSURE = "admin/closure/delete";

// NOTIFICATION
export const GET_ALL_NOTIFICATIONS = "admin/push-notification/all";
export const UPDATE_NOTIFICATION = "admin/push-notification/details/update";
export const SEND_NOTIFICATION = "admin/push-notification/broadcast";

// ORDERS
export const GET_ALL_ORDERS = "admin/booking/getAll";
export const GET_ORDER_details = "admin/booking/details";
export const CANCEL_ORDER = "admin/booking/cancelBooking";

// CUSTOMERS
export const GET_ALL_CUSTOMERS = "customer/all";
export const GET_CUSTOMER_DETAILS = "customer/details";
export const UPDATE_CUSTOMER_STATUS = "customer/details/update-status";
export const ADD_CUSTOMER = "organization/customer/add";
export const UPDATE_CUSTOMER = "organization/customer/update";

export const GENERATE_ORDER_INVOICE = "admin/booking/invoice";
export const GET_CUSTOMER_WALLET_TRANSACTIONS =
  "customer/getWalletTransactions";
export const GET_BOOKING_HISTORY = "customer/getUserBookings";
export const ADD_RECHARGE_TO_CUSTOMER_WALLET =
  "customer/rechargeCustomerWallet";
export const GET_CUSTOMERS_LIST = "customer/list";
export const GET_CUSTOMER_CHART_DETAILS = "customer/chart-details";
export const GET_PLATFORM_VERSIONS = "customer/platform-versions";

// DASHBOARD
export const GET_RATING_DASHBOARD_DETAILS = "admin/ratings/dashboard-details";
export const GET_RATING_HISTORY = "admin/ratings/history";
export const GET_OVERVIEW_DASHBOARD_DETAILS =
  "admin/overview/dashboard-details";
export const GET_OVERVIEW_DASHBOARD_SPACE_DETAILS =
  "admin/overview/dashboard-space-details";
export const GET_OVERVIEW_DASHBOARD_24_7_CHART =
  "admin/overview/dashboard-24x7-chart";
export const GET_DASHBOARD_BOOKING_DETAILS = "admin/booking/dashboard-details";
export const RATING_HISTORY_EXPORT = "admin/ratings/export";
export const GET_OVERVIEW_DASHBOARD_CHART_DETAILS =
  "admin/overview/dashboard-details-chart";
export const GET_OVERVIEW_COMPARISON_CHART = "admin/overview/comparison-chart";

// OFFERS
export const GET_ALL_OFFERS = "admin/offer/all";
export const ADD_OFFER = "admin/offer/add";
export const UPDATE_OFFER = "admin/offer/update-Offer";
export const GET_OFFER_LIST = "admin/offer/list";
export const GET_OFFER_DETAILS = "admin/offer/details";
export const UPDATE_OFFER_STATUS = "admin/offer/update-status";
export const DELETE_OFFER_STATUS = "admin/offer/delete";

// PLANS & PRICING
export const GET_PLANS = "admin/subscription-plan/all";
export const GET_PLAN_DETAILS = "admin/subscription-plan/details";
export const UPDATE_PLAN = "admin/subscription-plan/update";

// SUBSCRIPTIONS
export const GET_SUBSCRIPTIONS = "admin/organization-subscription/all";
export const GET_SUBSCRIPTION_DETAILS =
  "admin/organization-subscription/details";

// DEMO REQUEST
export const GET_DEMO_REQUESTS = "admin/demo-request/all";
export const GET_DEMO_REQUEST_DETAILS = "admin/demo-request/details";
export const UPDATE_DEMO_REQUEST_STATUS = "admin/demo-request/update-status";
export const DELETE_DEMO_REQUEST = "admin/demo-request/delete";
